import { useContext, useEffect, useState } from 'react'
import { useLazyQuery } from '@apollo/client';
import { GET_DELIST_AND_UNSOLD_BY_LOGITIX, GET_DELIST_AND_UNSOLD_TICKETS, GET_LIST_TICKETS, GET_LIST_TICKETS_BY_LOGITIXUSER } from '../../../features/Tickets/api/TicketsQuery';
import { CircularProgress } from '@mui/material';
import ToasterWithMessage from '../toaster';
import AppTable from '../table/AppTable';
import styles from '../../../features/Users/Users.module.css'
import { globalContext } from '../../../Provider/AppProvider';
import { roles } from '../../../helper';

const DelistAndUnsold = (props: any) => {
  const {
  rowsPerPage,
  currentPage,
  setCurrentPage, 
  checking,
  setChecking, 
  unsoldTicketList,
  setUnsoldTicketList,
  selected,
  setSelected,
  columnTypes,
  setColumnTypes,
  sortType,
  setSortType,
  GenerateUnsoldTicketHeadCells,
  handleChangeRowsPerPage,
  handlePageChange,
  activeTab
  } = props;

  const {globalState,handleGlobalState} = useContext<any>(globalContext);
  const [searchvalue, setSearchvalue] = useState(globalState?.globalSearch?.searchtext);
  const {error} = ToasterWithMessage();

  const [getUnsoldTickets, {loading}] = useLazyQuery(GET_DELIST_AND_UNSOLD_TICKETS,{
    fetchPolicy: 'no-cache',
    onCompleted: (unsoldTicketData) => {
        setUnsoldTicketList(unsoldTicketData);
        const tempState = {...globalState};
        tempState.unsoldTicketFilter.clicked = false;
        if(globalState.notification.notificationClicked){
        tempState.manageTicketFilter.notificationFilterDataCount = unsoldTicketData?.filtermanagetickets_aggregate?.aggregate?.count;
        tempState.listTicketFilter.notificationFilterDataCount = unsoldTicketData?.filterlisttickets_aggregate?.aggregate?.count;
        tempState.soldTicketFilter.notificationFilterDataCount = unsoldTicketData?.FilterSoldTickets_aggregate?.aggregate?.count;
        tempState.delistAndReturnTicketFilter.notificationFilterDataCount = unsoldTicketData?.filterreturntickets_aggregate?.aggregate?.count;
        tempState.unsoldTicketFilter.notificationFilterDataCount = unsoldTicketData?.filterUnsoldTickets_aggreagate?.aggregate?.count;
      }if(globalState.error.errorClicked){  
        tempState.manageTicketFilter.errorFilterDataCount = unsoldTicketData?.filtermanagetickets_aggregate?.aggregate?.count;
        tempState.listTicketFilter.errorFilterDataCount = unsoldTicketData?.filterlisttickets_aggregate?.aggregate?.count;
        tempState.soldTicketFilter.errorFilterDataCount =unsoldTicketData?.FilterSoldTickets_aggregate?.aggregate?.count;  
        tempState.delistAndReturnTicketFilter.errorFilterDataCount = unsoldTicketData?.filterreturntickets_aggregate?.aggregate?.count;
        tempState.unsoldTicketFilter.errorFilterDataCount = unsoldTicketData?.filterUnsoldTickets_aggreagate?.aggregate?.count;
        tempState.unsoldTicketFilter.clicked = false;
      }
        handleGlobalState(tempState);
    },
    onError: () => {
        error("We’re having trouble connecting. Please clear your cache, refresh the page, and try again.");
    }
  })
  

  const [getUnsoldTicketsByLogitix, {loading:logitixLoading}] = useLazyQuery(GET_DELIST_AND_UNSOLD_BY_LOGITIX,{
    fetchPolicy: 'no-cache',
    onCompleted: (logitixUnsoldTicketData) => {
        setUnsoldTicketList(logitixUnsoldTicketData);
        const tempState = {...globalState};
        tempState.unsoldTicketFilter.clicked = false;
        if(globalState.notification.notificationClicked){
        tempState.manageTicketFilter.notificationFilterDataCount = logitixUnsoldTicketData?.filtermanagetickets_aggregate?.aggregate?.count;
        tempState.listTicketFilter.notificationFilterDataCount = logitixUnsoldTicketData?.filterlisttickets_aggregate?.aggregate?.count;
        tempState.soldTicketFilter.notificationFilterDataCount = logitixUnsoldTicketData?.FilterSoldTickets_aggregate?.aggregate?.count;
        tempState.delistAndReturnTicketFilter.notificationFilterDataCount = logitixUnsoldTicketData?.filterreturntickets_aggregate?.aggregate?.count;
        tempState.unsoldTicketFilter.notificationFilterDataCount = logitixUnsoldTicketData?.filterUnsoldTickets_aggreagate?.aggregate?.count;
      }if(globalState.error.errorClicked){  
        tempState.manageTicketFilter.errorFilterDataCount = logitixUnsoldTicketData?.filtermanagetickets_aggregate?.aggregate?.count;
        tempState.listTicketFilter.errorFilterDataCount = logitixUnsoldTicketData?.filterlisttickets_aggregate?.aggregate?.count;
        tempState.soldTicketFilter.errorFilterDataCount =logitixUnsoldTicketData?.FilterSoldTickets_aggregate?.aggregate?.count;  
        tempState.delistAndReturnTicketFilter.errorFilterDataCount =logitixUnsoldTicketData?.filterreturntickets_aggregate?.aggregate?.count;  
        tempState.unsoldTicketFilter.errorFilterDataCount =logitixUnsoldTicketData?.filterUnsoldTickets_aggreagate?.aggregate?.count;  
        tempState.unsoldTicketFilter.clicked = false;
      }
        handleGlobalState(tempState);
    },
    onError: () => {
        error("We’re having trouble connecting. Please clear your cache, refresh the page, and try again.");
    }
  })

  useEffect(() => {
    const tempdata = {...globalState}
    setSearchvalue(tempdata?.globalSearch?.searchtext)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalState?.globalSearch?.searchtext]);

  useEffect(() => {
    const unsoldTicketsVariables={
      leagueId: globalState?.unsoldTicketFilter?.leagueId,
      ticketStatus: globalState?.unsoldTicketFilter?.ticketStatus,
       startdate:globalState?.unsoldTicketFilter?.startdate ? globalState?.unsoldTicketFilter?.startdate : globalState?.unsoldTicketFilter?.startDateRange,
       enddate:globalState?.unsoldTicketFilter?.enddate ? globalState?.unsoldTicketFilter?.enddate : globalState?.unsoldTicketFilter?.endDateRange,
       pageSize: rowsPerPage,
       pageOffset: (currentPage -1)*rowsPerPage,
       order_by: [{[columnTypes]: sortType},{"tp_id": "asc"}],
       search_event:searchvalue === globalState.notification.text ?"%":searchvalue === globalState.error.text ?"%":`${searchvalue}%`,
       ticketId:globalState.notification.ticketId,
       ticketPlacementId: globalState.notification.tpId,
       array_tpid: globalState?.notification.tp_id_array?globalState?.notification.tp_id_array:globalState?.error?.approximateTpArray?.length > 0  ? globalState.error.approximateTpArray : globalState.error.ticketPlacementId
      };

    if((globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN)){
    getUnsoldTickets({
      variables: unsoldTicketsVariables
    })
  }else{
    getUnsoldTicketsByLogitix({
      variables: unsoldTicketsVariables
    })
  }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalState?.globalSearch?.searchtext,searchvalue,globalState.notification.notificationSearchCancel]);

useEffect(()=>{
  if(activeTab === 4){
    const ticketsVariables= {
      leagueId:  globalState?.notification?.notificationClicked ? null: globalState?.error?.errorClicked? null : globalState?.unsoldTicketFilter?.leagueId,
      ticketStatus:  globalState?.notification?.notificationClicked ? null: globalState?.error?.errorClicked ? null : globalState?.unsoldTicketFilter?.ticketStatus,
       startdate:  globalState?.notification?.notificationClicked ? null:globalState?.error?.errorClicked? null : globalState?.unsoldTicketFilter?.startdate ? globalState?.unsoldTicketFilter?.startdate : globalState?.unsoldTicketFilter?.startDateRange,
       enddate:  globalState?.notification?.notificationClicked ? null:globalState?.error?.errorClicked? null : globalState?.unsoldTicketFilter?.enddate ? globalState?.unsoldTicketFilter?.enddate : globalState?.unsoldTicketFilter?.endDateRange,
       pageSize: rowsPerPage,
       pageOffset: (currentPage -1)*rowsPerPage,
       order_by: [{[columnTypes]: sortType}, {"tp_id": "asc"}],
       search_event:searchvalue === globalState.notification.text ?"%":searchvalue === globalState.error.text ?"%":`${searchvalue}%`,
       ticketId:globalState.notification.ticketId,
       ticketPlacementId: globalState.notification.tpId,
       array_tpid: globalState?.notification.tp_id_array?globalState?.notification.tp_id_array:globalState?.error?.approximateTpArray?.length > 0  ? globalState.error.approximateTpArray : globalState.error.ticketPlacementId
      };

    if((globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN)){
    getUnsoldTickets({
      variables:ticketsVariables
    })
  }else{
    getUnsoldTicketsByLogitix({
      variables: ticketsVariables
    })
  }
  }

// eslint-disable-next-line react-hooks/exhaustive-deps
},[activeTab,
  getUnsoldTickets,
  rowsPerPage,
  currentPage,
  sortType,
  columnTypes,
  searchvalue,
]);

useEffect(()=>{
  if(globalState.unsoldTicketFilter.clicked){
    const getUnsoldTicketsVariables={
      leagueId: globalState?.unsoldTicketFilter?.leagueId,
      ticketStatus: globalState?.unsoldTicketFilter?.ticketStatus,
       startdate:globalState?.unsoldTicketFilter?.startdate ? globalState?.unsoldTicketFilter?.startdate : globalState?.unsoldTicketFilter?.startDateRange,
       enddate:globalState?.unsoldTicketFilter?.enddate ? globalState?.unsoldTicketFilter?.enddate : globalState?.unsoldTicketFilter?.endDateRange,
       pageSize: rowsPerPage,
       pageOffset: (currentPage -1)*rowsPerPage,
       order_by: [{[columnTypes]: sortType}, {"tp_id": "asc"}],
       search_event: `${searchvalue}%`,
       ticketId:globalState.notification.ticketId,
       ticketPlacementId: globalState.notification.tpId,
       array_tpid: globalState?.notification.tp_id_array?globalState?.notification.tp_id_array:globalState?.error?.approximateTpArray?.length > 0  ? globalState.error.approximateTpArray : globalState.error.ticketPlacementId
      };

    if((globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN)){
    getUnsoldTickets({
      variables: getUnsoldTicketsVariables
    });
  }else{
    getUnsoldTicketsByLogitix({
      variables: getUnsoldTicketsVariables
    });
  }
  }

// eslint-disable-next-line react-hooks/exhaustive-deps
},[
  getUnsoldTickets,
  globalState.unsoldTicketFilter.clicked
]);
  return (
    <>
      {
        (loading || logitixLoading)
      ?   <div className={styles.TableCircularProgress}>
          <CircularProgress color="primary" size={35} />
          </div>
      :
         <AppTable
           handleChangeRowsPerPage={handleChangeRowsPerPage}
           handlePageChange={handlePageChange}
           setColumnTypes = {setColumnTypes}
           sortType = {sortType}
           setSortType = {setSortType}
           setSelected = {setSelected}
           setChecking = {setChecking}
           checking = {checking}
           selected ={selected}
           rowsPerPage = {rowsPerPage}
           setCurrentPage={setCurrentPage}
           currentPage= {currentPage}
           list={unsoldTicketList}
           tableTitle = "delistAndUnsoldTickets"
           generateHeadCells = {GenerateUnsoldTicketHeadCells}
         />
      }
    </>
  );
}

export default DelistAndUnsold
